/**
 * Example JavaScript singleton module
 */

var Slider = (function($) {
  function initSliderLanding() {
    const heroSwiper = new Swiper(".home-slider", {
      slidesPerView: 1,
      loop: true,
      speed: 1000,
      effect: "fade",
      fadeEffect: {
        crossFade: true
      },
      autoplay: {
        delay: 3000, // cambia cada 4 segundos
        disableOnInteraction: false
      }
      //   pagination: {
      //     el: ".swiper-pagination",
      //     clickable: true
      //   },
      //   navigation: {
      //     nextEl: ".swiper-button-next",
      //     prevEl: ".swiper-button-prev"
      //   }
    });
  }

  function initSliderHome() {
    $(".landing-swiper").each(function() {
      const $slider = $(this);

      const swiper = new Swiper(this, {
        slidesPerView: 1,
        loop: false,
        speed: 400,
        allowTouchMove: true,

        effect: "fade",

        fadeEffect: {
          crossFade: true
        }
      });

      const totalSlides = swiper.slides.length;

      /*
       * PREV
       */
      $slider.find(".project-item__slider-nav--prev").on("click", function(e) {
        e.preventDefault();
        e.stopPropagation();

        let target = swiper.activeIndex - 1;

        if (target < 0) {
          target = totalSlides - 1;
        }

        swiper.slideTo(target);
      });

      /*
       * NEXT
       */
      $slider.find(".project-item__slider-nav--next").on("click", function(e) {
        e.preventDefault();
        e.stopPropagation();

        let target = swiper.activeIndex + 1;

        if (target >= totalSlides) {
          target = 0;
        }

        swiper.slideTo(target);
      });
    });
  }

  function initSliderProject() {
    $(".project-item__slider").each(function() {
      const $slider = $(this);

      const swiper = new Swiper(this, {
        slidesPerView: 1,
        loop: false,
        speed: 400,
        allowTouchMove: true,

        effect: "fade",

        fadeEffect: {
          crossFade: true
        },

        on: {
          init: function() {
            setSliderMediaHeight($slider);
          },

          resize: function() {
            setSliderMediaHeight($slider);
          }
        }
      });

      const totalSlides = swiper.slides.length;

      /*
       * PREV
       */
      $slider.find(".project-item__slider-nav--prev").on("click", function(e) {
        e.preventDefault();
        e.stopPropagation();

        let target = swiper.activeIndex - 1;

        // Si estamos en la primera,
        // vamos a la última.
        if (target < 0) {
          target = totalSlides - 1;
        }

        swiper.slideTo(target);
      });

      /*
       * NEXT
       */
      $slider.find(".project-item__slider-nav--next").on("click", function(e) {
        e.preventDefault();
        e.stopPropagation();

        let target = swiper.activeIndex + 1;

        // Si estamos en la última,
        // volvemos a la primera.
        if (target >= totalSlides) {
          target = 0;
        }

        swiper.slideTo(target);
      });
    });
  }

  function setSliderMediaHeight($slider) {
    if (!$slider || !$slider.length) {
      return;
    }
    const sliderWidth = $slider.width();
    const $projectItem = $slider.closest(".project-item");

    const columnSpan =
      parseInt(
        getComputedStyle($projectItem[0]).getPropertyValue("--column-span")
      ) || 12;

    const images = [];

    $slider.find(".project-item__slide-inner img").each(function() {
      if (!this.naturalWidth || !this.naturalHeight) {
        return;
      }

      images.push({
        width: this.naturalWidth,
        height: this.naturalHeight,
        ratio: this.naturalWidth / this.naturalHeight
      });
    });

    if (!images.length) {
      return;
    }

    let mediaHeight = 0;

    /*
     * SLIDERS ESTRECHOS
     *
     * La imagen más alta define la altura.
     * Perfecto para combinar portraits + landscape.
     */
    if (columnSpan <= 5) {
      images.forEach(function(image) {
        /*
         * Altura que tendría la imagen
         * ocupando todo el ancho del slider.
         */
        const height = sliderWidth / image.ratio;

        if (height > mediaHeight) {
          mediaHeight = height;
        }
      });
    } else {
      /*
       * SLIDERS ANCHOS
       *
       * La imagen más landscape define la altura.
       */
      let landscapeRatio = 0;

      images.forEach(function(image) {
        if (image.ratio > landscapeRatio) {
          landscapeRatio = image.ratio;
        }
      });

      mediaHeight = sliderWidth / landscapeRatio;
    }

    $slider.find(".project-item__slide-inner").height(mediaHeight);
  }

  function init() {
    // return early if no corresponding module present
    // if (!$(".swiper").length) {
    //   return;
    // }

    if ($(".page-template-template-landing").length) {
      initSliderHome();
    }

    if ($(".home").length) {
      initSliderLanding();
    }

    if ($(".single-project").length) {
      initSliderProject();
    }
  }

  return {
    init: init
  };
})(jQuery);

jQuery(document).ready(Slider.init);
